"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClientInstance = exports.getServerInstance = void 0;
const server_1 = require("./server");
const client_1 = require("./client");
const defaultInstance = (0, server_1.isSSR)()
    ? (0, server_1.getServerInstance)()
    : (0, client_1.getClientInstance)();
exports.default = defaultInstance;
exports.getServerInstance = server_1.getServerInstance;
exports.getClientInstance = client_1.getClientInstance;
//# sourceMappingURL=index.js.map